/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedCallDealerCta_item = {
    readonly serviceId: string | null;
    readonly seller: {
        readonly id: string;
        readonly serviceId: string | null;
        readonly favoritesByUser?: ReadonlyArray<{
            readonly serviceId: string | null;
        } | null> | null;
        readonly trackedPhone: {
            readonly phoneNumber: string | null;
        } | null;
    } | null;
    readonly " $refType": "PdpSharedCallDealerCta_item";
};
export type PdpSharedCallDealerCta_item$data = PdpSharedCallDealerCta_item;
export type PdpSharedCallDealerCta_item$key = {
    readonly " $data"?: PdpSharedCallDealerCta_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedCallDealerCta_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedCallDealerCta_item",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Phone",
          "kind": "LinkedField",
          "name": "trackedPhone",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "phoneNumber",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "condition": "fetchUser",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "userIds",
                  "variableName": "userId"
                }
              ],
              "concreteType": "Favorite",
              "kind": "LinkedField",
              "name": "favoritesByUser",
              "plural": true,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();
(node as any).hash = 'c156f13afd9eede699f3979b15d3ea7e';
export default node;
